import  { GetterTree } from "vuex";
import PropertyStoreTypes from "./define-types.store";
import { IReportState } from "../states.store";
import {
  ReportPrintTemplateModel,
  ReportDocumentModelDto,
  ReportPrintTemplateTemplatesLookupModel
} from "../../../models/report";
const descriptionGetters: GetterTree<IReportState, {}> = <GetterTree<IReportState,{}>>{
  service: (state: IReportState) => state.service,
  propertyService: (state: IReportState) => state.propertyService,
  projectService: (state: IReportState) => state.projectService,
  demandService: (state: IReportState) => state.demandService,
  personService: (state: IReportState) => state.personService,

  /** GET ALL CURRENT SEND EMAIL MODEL */
  [PropertyStoreTypes.Get.GET_PRINTTEMPLATE]: (state: IReportState) => {
    return state.printTemplate || new ReportPrintTemplateModel();
  },

  /** GET TEMPLATE LOOKUP */
  [PropertyStoreTypes.Get.GET_LOOKUP_TEMPLATES]: (state: IReportState) => {
    return (
      state.printTemplateLookup.Templates || new ReportPrintTemplateTemplatesLookupModel()
    );
  },

  /** GET DOCUMENTS*/
  [PropertyStoreTypes.Get.GET_LOOKUP_DOCUMENTS]: (state: IReportState) => {
    return state.printTemplateLookup.Documents || new ReportDocumentModelDto();
  },

  /** GET PROPERTIES*/
  [PropertyStoreTypes.Get.GET_LOOKUP_PROPERTIES]: (state: IReportState) => {
    return state.printTemplateLookup.Properties || [];
  },

  /** GET PROJECTS*/
  [PropertyStoreTypes.Get.GET_LOOKUP_PROJECTS]: (state: IReportState) => {
    return state.printTemplateLookup.Projects || [];
  },

  /** GET DEMANDS*/
  [PropertyStoreTypes.Get.GET_LOOKUP_DEMANDS]: (state: IReportState) => {
    return state.printTemplateLookup.Demands || [];
  },

  /** GET PERSONS*/
  [PropertyStoreTypes.Get.GET_LOOKUP_PERSONS]: (state: IReportState) => {
    return state.printTemplateLookup.Persons || [];
  }
};

export default descriptionGetters;
